var map = {
	"./About_ys_small_1.png": "abaf",
	"./About_ys_small_2.png": "8dee",
	"./About_ys_small_3.png": "dcee",
	"./About_ys_small_4.png": "843ee",
	"./About_ys_small_5.png": "259d",
	"./About_ys_small_6.png": "23ee7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9feb";